
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Loader } from "lucide-react";
import { useTranslation } from "react-i18next";

interface TemplateDeleteDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  templateName: string;
  onConfirm: () => void;
  isDeleting: boolean;
}

const TemplateDeleteDialog = ({
  isOpen,
  onOpenChange,
  templateName,
  onConfirm,
  isDeleting,
}: TemplateDeleteDialogProps) => {
  const { t } = useTranslation();
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t('templates.delete_dialog.title')}</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <p>{t('templates.delete_dialog.confirm', { name: templateName })}</p>
          <p className="text-sm text-muted-foreground">{t('templates.delete_dialog.warning')}</p>
          <div className="flex gap-3">
            <Button
              variant="destructive"
              onClick={onConfirm}
              disabled={isDeleting}
            >
              {isDeleting ? (
                <>
                  <Loader size={16} className="mr-2 animate-spin" />
                  {t('templates.delete_dialog.deleting')}
                </>
              ) : (
                t('templates.delete_dialog.delete_btn')
              )}
            </Button>
            <Button
              variant="outline"
              onClick={() => onOpenChange(false)}
            >
              {t('templates.delete_dialog.cancel_btn')}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default TemplateDeleteDialog;